import links from 'appConfig/video';

import { getLanguage } from 'api/utils/languageManagment';

import isMobile from './isMobile';

type KeyType = keyof typeof links.videoLinks.ios;

function isListedLanguage(language: string): language is KeyType {
  return language in links.videoLinks.ios;
}

export const getVideoLink = () => {
  const language = getLanguage();

  if (isMobile.android()) {
    return isListedLanguage(language) ? links.videoLinks.android[language] : links.videoLinks.android['en'];
  }

  return isListedLanguage(language) ? links.videoLinks.ios[language] : links.videoLinks.ios['en'];
};
